import React from "react";
import ReactDOM from "react-dom/client";
import { useEffect, useState } from "react";


const Hero2 = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const images = window.SHOPIFY_IMAGES || [];


    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000); // Change every 3 seconds

        return () => clearInterval(interval); // Cleanup on unmount
    }, [images.length]);

    return (


        <img
            src={images[currentIndex]}
            alt="Child with backpack"
            class="" />


    );
};

// ✅ Render React Component in Liquid File
const rootEl = document.getElementById("react-hero-images2");
if (rootEl) {
    ReactDOM.createRoot(rootEl).render(<Hero2 />);
}
